import { Navigate, Route, Routes } from "react-router";
import React from "react";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import LoginScreen from "./Pages/LoginScreen";
import MainStudentScreen from "./Pages/MainStudentScreen";
import MainEmployeeScreen from "./Pages/MainEmployeeScreen";
import CreateRequestScreen from "./Components/Create-Request/CreateRequestScreen";
import styled from "styled-components";
import { ToastContainer, toast } from "react-toastify";
import SettingScreen from "./Components/Settings/SettingScreen";
import AllRequestScreen from "./Components/All-Request/AllRequestScreen";
import CheckRequest from "./Components/Check-Request/CheckRequest";
import AllStudentList from "./Components/All-Students/AllStudentList";
import CheckedRequest from "./Components/Checked-Request/CheckedRequest";
import AllEmployees from "./Components/All-Employees/AllEmployees";
import RequestResultStudent from "./Components/Request-Results-Student/RequestResultStudent";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Backdrop } from "@mui/material";
import Lottie from "lottie-react";
import LoadingAnimation from "./Loading.json";

function App() {
  const LoadingData = useSelector((state) => state.loadingState);
  return (
    <Container>
      <Routes>
        <Route path="/login" element={<LoginScreen></LoginScreen>}></Route>
        <Route
          path="/dashboard"
          element={<MainStudentScreen></MainStudentScreen>}
        >
          <Route
            path="/dashboard/create-request"
            element={
              <ProtectedStu>
                <CreateRequestScreen></CreateRequestScreen>
              </ProtectedStu>
            }
          ></Route>
          <Route
            path="/dashboard/all-request"
            element={
              <ProtectedStu>
                <AllRequestScreen></AllRequestScreen>
              </ProtectedStu>
            }
          ></Route>
          <Route
            path="/dashboard/all-request/result"
            element={
              <ProtectedStu>
                <RequestResultStudent></RequestResultStudent>
              </ProtectedStu>
            }
          ></Route>
          <Route
            path="/dashboard/setting"
            element={
              <ProtectedStu>
                <SettingScreen></SettingScreen>
              </ProtectedStu>
            }
          ></Route>
          <Route
            path="/dashboard/*"
            element={
              <ProtectedStu>
                <Navigate to={"/dashboard/create-request"} />
              </ProtectedStu>
            }
          ></Route>
          <Route
            path=""
            element={
              <ProtectedStu>
                <Navigate to={"/dashboard/create-request"} />
              </ProtectedStu>
            }
          ></Route>
        </Route>
        <Route
          path="/admin-dashboard"
          element={
            <ProtectedEmp>
              <MainEmployeeScreen></MainEmployeeScreen>
            </ProtectedEmp>
          }
        >
          <Route
            path="/admin-dashboard/check-request"
            element={
              <ProtectedEmp>
                <CheckRequest></CheckRequest>
              </ProtectedEmp>
            }
          ></Route>
          <Route
            path="/admin-dashboard/checked-request"
            element={<CheckedRequest></CheckedRequest>}
          ></Route>
          <Route
            path="/admin-dashboard/all-employees"
            element={<AllEmployees></AllEmployees>}
          ></Route>
          <Route
            path="/admin-dashboard/all-students"
            element={
              <ProtectedEmp>
                <AllStudentList></AllStudentList>
              </ProtectedEmp>
            }
          ></Route>
          <Route path="/admin-dashboard/system-data" element={<></>}></Route>
          <Route
            path="/admin-dashboard/*"
            element={
              <ProtectedEmp>
                <Navigate to={"/admin-dashboard/check-request"} />
              </ProtectedEmp>
            }
          ></Route>
          <Route
            path=""
            element={
              <ProtectedEmp>
                <Navigate to={"/admin-dashboard/check-request"} />
              </ProtectedEmp>
            }
          ></Route>
        </Route>
        <Route path="/*" element={<Navigate to={"/login"} />}></Route>
      </Routes>
      <ToastContainer rtl position={toast.POSITION.TOP_LEFT} icon={false} />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={LoadingData.loading}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignContent: "center",
        }}
      >
        <Lottie
          animationData={LoadingAnimation}
          loop={true}
          style={{ scale: "1.5", height: "150px" }}
        />
        <LoadingText>در حال پردازش لطفا منتظر بمانید...</LoadingText>
      </Backdrop>
    </Container>
  );
}

function ProtectedEmp({ children }) {
  const [userRole] = useState(localStorage.getItem("role"));
  if (userRole?.length === 0) {
    return <Navigate to="/login" replace />;
  }
  if (userRole === "stu") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

function ProtectedStu({ children }) {
  const [userRole] = useState(localStorage.getItem("role"));
  if (userRole?.length === 0) {
    return <Navigate to="/login" replace />;
  }
  if (userRole === "emp") {
    return <Navigate to="/admin-dashboard" replace />;
  }
  return children;
}

export default App;

const Container = styled.div`
  position: relative;
  box-sizing: border-box;
`;

const LoadingText = styled.h2`
  font-weight: 700;
  font-family: "iranSans";
  font-size: 19px;
`;
